const state = {
  dialIsShowPhoneOnNavbar: false,
  dialBotSessionId: '',
  dialChannelName: '',
  dialPhoneNumber: '',
  dialDtmf: '',
  dialTo: '',
  dialVolume: 1,
  dialIsAllow: false,
  dialIsCalling: false,
  dialIsOnHold: false,
  dialIsOnMute: false,
  dialIsOpenPanel: false,
  dialIsShowNumPads: false,
  dialSession: null,
  dialUa: null,

  dialTime: null,
  dialTimeBegan: null,
  dialTimeStarted: null,
  dialTimeStopped: null,
  dialTimeStoppedDuration: 0,
  dialTimeRunning: false,
  dialTimerBegan: null
}

const actions = {
  setDialIsShowPhoneOnNavbar({ commit }, value) {
    commit('setDialIsShowPhoneOnNavbar', value)
  },
  setDialBotSessionId({ commit }, value) {
    commit('setDialBotSessionId', value)
  },
  clearDialBotSessionId({ commit }) {
    commit('clearDialBotSessionId')
  },
  setDialChannelName({ commit }, value) {
    commit('setDialChannelName', value)
  },
  clearDialChannelName({ commit }) {
    commit('clearDialChannelName')
  },
  setDialPhoneNumber({ commit }, value) {
    commit('setDialPhoneNumber', value)
  },
  clearDialPhoneNumber({ commit }) {
    commit('clearDialPhoneNumber')
  },
  setDialDtmf({ commit }, value) {
    commit('setDialDtmf', value)
  },
  clearDialDtmf({ commit }) {
    commit('clearDialDtmf')
  },
  pressNumPad({ commit }, value) {
    commit('pressNumPad', value)
  },
  delNumPad({ commit }) {
    commit('delNumPad')
  },
  setDialTo({ commit }, value) {
    commit('setDialTo', value)
  },
  clearDialTo({ commit }) {
    commit('clearDialTo')
  },
  setDialVolume({ commit }, value) {
    commit('setDialVolume', value)
  },
  clearDialVolume({ commit }) {
    commit('clearDialVolume')
  },
  setDialIsAllow({ commit }, value) {
    commit('setDialIsAllow', value)
  },
  clearDialIsAllow({ commit }) {
    commit('clearDialIsAllow')
  },
  setDialIsCalling({ commit }, value) {
    commit('setDialIsCalling', value)
  },
  clearDialIsCalling({ commit }) {
    commit('clearDialIsCalling')
  },
  setDialIsOnHold({ commit }, value) {
    commit('setDialIsOnHold', value)
  },
  clearDialIsOnHold({ commit }) {
    commit('clearDialIsOnHold')
  },
  setDialIsOnMute({ commit }, value) {
    commit('setDialIsOnMute', value)
  },
  clearDialIsOnMute({ commit }) {
    commit('clearDialIsOnMute')
  },
  setDialIsShowNumPads({ commit }, value) {
    commit('setDialIsShowNumPads', value)
  },
  clearDialIsShowNumPads({ commit }) {
    commit('clearDialIsShowNumPads')
  },
  toggleDialPad({ commit }) {
    commit('toggleDialPad')
  },
  setDialIsOpenPanel({ commit }, value) {
    commit('setDialIsOpenPanel', value)
  },
  clearDialIsOpenPanel({ commit }) {
    commit('clearDialIsOpenPanel')
  },
  toggleDialPanel({ commit }) {
    commit('toggleDialPanel')
  },
  setDialSession({ commit }, value) {
    commit('setDialSession', value)
  },
  setDialUa({ commit }, value) {
    commit('setDialUa', value)
  },

  setDialTime({ commit }, value) {
    commit('setDialTime', value)
  },
  setDialTimeBegan({ commit }, value) {
    commit('setDialTimeBegan', value)
  },
  setDialTimeStarted({ commit }, value) {
    commit('setDialTimeStarted', value)
  },
  setDialTimeStopped({ commit }, value) {
    commit('setDialTimeStopped', value)
  },
  setDialTimeStoppedDuration({ commit }, value) {
    commit('setDialTimeStoppedDuration', value)
  },
  setDialTimeRunning({ commit }, value) {
    commit('setDialTimeRunning', value)
  },
  setDialTimerBegan({ commit }, value) {
    commit('setDialTimerBegan', value)
  }
}

const mutations = {
  setDialIsShowPhoneOnNavbar(state, bool) {
    state.dialIsShowPhoneOnNavbar = bool
  },
  setDialBotSessionId(state, id) {
    state.dialBotSessionId = id
  },
  clearDialBotSessionId(state) {
    state.dialBotSessionId = ''
  },
  setDialChannelName(state, name) {
    state.dialChannelName = name
  },
  clearDialChannelName(state) {
    state.dialChannelName = ''
  },
  setDialPhoneNumber(state, number) {
    state.dialPhoneNumber = number
  },
  clearDialPhoneNumber(state) {
    state.dialPhoneNumber = ''
  },
  setDialDtmf(state, number) {
    state.dialDtmf = number
  },
  clearDialDtmf(state) {
    state.dialDtmf = ''
  },
  pressNumPad(state, number) {
    if (!state.dialIsCalling) {
      state.dialPhoneNumber = `${state.dialPhoneNumber || ''}${number}`
    } else {
      state.dialDtmf = `${state.dialDtmf || ''}${number}`
    }
  },
  delNumPad(state) {
    if (!state.dialIsCalling) {
      if (state.dialPhoneNumber.length >= 1) {
        state.dialPhoneNumber = state.dialPhoneNumber.substring(
          0,
          state.dialPhoneNumber.length - 1
        )
      }
    } else {
      if (state.dialDtmf.length >= 1) {
        state.dialDtmf = state.dialDtmf.substring(0, state.dialDtmf.length - 1)
      }
    }
  },
  setDialTo(state, name) {
    state.dialTo = name
  },
  clearDialTo(state) {
    state.dialTo = ''
  },
  setDialVolume(state, volume) {
    state.dialVolume = volume
  },
  clearDialVolume(state) {
    state.dialVolume = 1
  },
  setDialIsAllow(state, bool) {
    state.dialIsAllow = bool
  },
  clearDialIsAllow(state) {
    state.dialIsAllow = false
  },
  setDialIsCalling(state, bool) {
    state.dialIsCalling = bool
  },
  clearDialIsCalling(state) {
    state.dialIsCalling = false
  },
  setDialIsOnHold(state, bool) {
    state.dialIsOnHold = bool
  },
  clearDialIsOnHold(state) {
    state.dialIsOnHold = false
  },
  setDialIsOnMute(state, bool) {
    state.dialIsOnMute = bool
  },
  clearDialIsOnMute(state) {
    state.dialIsOnMute = false
  },
  setDialIsShowNumPads(state, bool) {
    state.dialIsShowNumPads = bool
  },
  clearDialIsShowNumPads(state) {
    state.dialIsShowNumPads = false
  },
  toggleDialPad(state) {
    state.dialIsShowNumPads = !state.dialIsShowNumPads
  },
  setDialIsOpenPanel(state, bool) {
    state.dialIsOpenPanel = bool
  },
  clearDialIsOpenPanel(state) {
    state.dialIsOpenPanel = false
  },
  toggleDialPanel(state) {
    state.dialIsOpenPanel = !state.dialIsOpenPanel
  },
  setDialSession(state, data) {
    state.dialSession = data
  },
  setDialUa(state, data) {
    state.dialUa = data
  },

  setDialTime(state, value) {
    state.dialTime = value
  },
  setDialTimeBegan(state, value) {
    state.dialTimeBegan = value
  },
  setDialTimeStarted(state, value) {
    state.dialTimeStarted = value
  },
  setDialTimeStopped(state, value) {
    state.dialTimeStopped = value
  },
  setDialTimeStoppedDuration(state, value) {
    state.dialTimeStoppedDuration = value
  },
  setDialTimeRunning(state, value) {
    state.dialTimeRunning = value
  },
  setDialTimerBegan(state, value) {
    state.dialTimerBegan = value
  }
}

export const call = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters: {
    dialIsShowPhoneOnNavbar: state => state.dialIsShowPhoneOnNavbar,
    dialBotSessionId: state => state.dialBotSessionId,
    dialChannelName: state => state.dialChannelName,
    dialPhoneNumber: state => state.dialPhoneNumber,
    dialDtmf: state => state.dialDtmf,
    dialTo: state => state.dialTo,
    dialVolume: state => state.dialVolume,
    dialIsAllow: state => state.dialIsAllow,
    dialIsCalling: state => state.dialIsCalling,
    dialIsOnHold: state => state.dialIsOnHold,
    dialIsOnMute: state => state.dialIsOnMute,
    dialIsOpenPanel: state => state.dialIsOpenPanel,
    dialIsShowNumPads: state => state.dialIsShowNumPads,
    dialSession: state => state.dialSession,
    dialUa: state => state.dialUa,

    dialTime: state => state.dialTime,
    dialTimeBegan: state => state.dialTimeBegan,
    dialTimeStarted: state => state.dialTimeStarted,
    dialTimeStopped: state => state.dialTimeStopped,
    dialTimeStoppedDuration: state => state.dialTimeStoppedDuration,
    dialTimeRunning: state => state.dialTimeRunning,
    dialTimerBegan: state => state.dialTimerBegan
  }
}
